import { FieldsRenderer } from '@neo/blocks/forms/fields-renderer'
import type { GenericFormType } from '@neo/blocks/forms/types'
import type React from 'react'
import { useMemo } from 'react'
import { z } from 'zod'
import { JsonKeyValueEditor } from '../../components/json-key-value-editor'
import type { HttpRequestNodeData } from '../../types'
import { parseJsonData } from '../../utils/http-request-utils'

type ParamsTabProps = {
  form: GenericFormType<HttpRequestNodeData['config']>
  nodeVars: string[]
}

export const ParamsTab: React.FC<ParamsTabProps> = ({ form, nodeVars }) => {
  // Memoize the parsed initial data to prevent unnecessary recalculations
  const initialData = useMemo(
    () => parseJsonData(form.state.values.http_request.params),
    [form.state.values.http_request.params],
  )

  const JsonKeyValueComponent = () => {
    const handleParamsChange = (
      newParams: Record<
        string,
        string | number | boolean | null | Record<string, unknown> | unknown[]
      >,
    ) => {
      form.setFieldValue('http_request.params', JSON.stringify(newParams))
    }
    return (
      <JsonKeyValueEditor
        showSecretVariables
        initialData={initialData}
        nodeVars={nodeVars}
        onChange={handleParamsChange}
      />
    )
  }

  return (
    <FieldsRenderer
      fields={[
        {
          name: 'http_request.params',
          type: 'custom',
          label: 'Query Params',
          zodValidation: z.string().optional(),
          component: JsonKeyValueComponent,
        },
      ]}
      form={form}
    />
  )
}
